import { render, staticRenderFns } from "./ManageTagsModal.vue?vue&type=template&id=5e94f1b7&scoped=true"
import script from "./ManageTagsModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./ManageTagsModal.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./ManageTagsModal.vue?vue&type=style&index=0&id=5e94f1b7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e94f1b7",
  null
  
)

export default component.exports